import React, { useState } from 'react'
import { useQuery } from 'react-query'



import StatusBadge from '../UI/statusBadge';
import { getTransactions } from '../../MyApi/transactions';
import DataTable from '../UI/table/DataTable';
import { formatPrice } from '../../utils/formatPrice';
import TransactionsStatusBadgeType from '../UI/transactionsStatusBadgeType';
import TransactionsStatusBadge from '../UI/transactionsstatusbadge';

const TransactionsInfo = ({id}) => {
    const [currentPage, setCurrentPage] = useState(1);
    const {data ,isLoading}=useQuery(["getTransactions", currentPage, id],()=>getTransactions(currentPage, {delivery_company_id: id, transactionable_type: "delivery_company"}))  
    const transactions =data?.data?.transactions ||{}
    const totalItems = data?.data?.pagination?.total || 0;
    const itemsPerPage = data?.data?.pagination?.last_page || 0;
    
    const transactionsColumns = [      
    { label: "معرف العملية", accessor: "id" },
    { label: "المحول", accessor: "transactionable.name" },  
    { 
      label: "نوع المعاملة", 
      render: (row) => <TransactionsStatusBadgeType  status={row.type} />
    },
    { 
      label: "المبلغ", 
      render: (row)=>(    
        <div className={`${(row.type ==="increment" ||row.type ==="deposit") ?"text-green":"text-danger"}`}>
          {row.currency} {formatPrice(row.currency_factor ,row.amount)} {`${(row.type ==="increment" ||row.type ==="deposit") ?"+":"-"}`}
        </div>
      )
    },
    { label: "طريقة الدفع", accessor: "payment_method" },
    { label: "التاريخ", accessor: "created_at" },
    { 
      label: "الحالة", 
      render: (row) =>  <TransactionsStatusBadge status={row.status} statusLabel={row.status} />
    },
  ]

  return (
    <div>
        <DataTable isLoading={isLoading} columns={transactionsColumns} data={transactions} currentPage={currentPage} setCurrentPage={setCurrentPage} totalItems={totalItems} itemsPerPage={itemsPerPage} />
    </div>
  )
}

export default TransactionsInfo